import FullBox from '@/components/full-box';
import { settingsMenu } from '@/configs/router/menu';
import styles from './index.module.scss';
import SettingMenu from './components/settingMenu';

const Settings = () => {
  const location = useLocation();
  return (
    <FullBox
      className={styles.settings}
      column
      frontChildren={<div className={styles.title}>Settings</div>}
    >
      <FullBox
        className={styles.content}
        frontClassName={styles.siderWrapper}
        centerClassName={styles.sectionWrapper}
        frontChildren={<SettingMenu />}
      >
        {settingsMenu.map((item) => (
          <div
            className={styles.section}
            key={item.key}
            hidden={item.key !== location.pathname}
          >
            {item.element}
          </div>
        ))}
      </FullBox>
    </FullBox>
  );
};
export default Settings;
